import { Navigate, useLocation } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import { useAuthStore } from '../../../store/authStore';
import { useSendFacebookCode } from '../../../apiHooks/mutations/integrationMutations/facebookMutation';
import LoadingSpinner from '../../loadingSpinner/loadingSpinner';
import {
  FACEBOOK_DEFAULT_RETURN_PATH,
  FACEBOOK_RETURN_URL_KEY,
  FACEBOOK_SELECT_AD_ACCOUNT_KEY,
} from '../../../constants/integrationConstants';

const FacebookRoute = () => {
  const { isLoggedIn } = useAuthStore();
  const [isConnecting, setIsConnecting] = useState(false);
  const [redirectTo, setRedirectTo] = useState<string | null>(null);
  const hasHandledCode = useRef(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const codeParam = queryParams.get('code');
  const { mutateAsync: sendFacebookCode } = useSendFacebookCode();

  useEffect(() => {
    if (codeParam && !isLoggedIn) {
      localStorage.setItem('facebookCode', codeParam);
      return;
    }

    if (!isLoggedIn || hasHandledCode.current) {
      return;
    }

    const code = codeParam || localStorage.getItem('facebookCode');
    if (!code) {
      return;
    }

    hasHandledCode.current = true;
    setIsConnecting(true);

    sendFacebookCode(code)
      .then(() => {
        localStorage.removeItem('facebookCode');
        const returnUrl = localStorage.getItem(FACEBOOK_RETURN_URL_KEY) || FACEBOOK_DEFAULT_RETURN_PATH;
        localStorage.removeItem(FACEBOOK_RETURN_URL_KEY);
        localStorage.setItem(FACEBOOK_SELECT_AD_ACCOUNT_KEY, 'true');
        setRedirectTo(returnUrl);
      })
      .finally(() => {
        setIsConnecting(false);
      });
  }, [codeParam, isLoggedIn, sendFacebookCode]);

  if (isConnecting) {
    return (
      <div className="flex h-full min-h-[240px] items-center justify-center">
        <LoadingSpinner color="primary" size={50} center />
      </div>
    );
  }

  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  if (isLoggedIn) {
    return <Navigate to={FACEBOOK_DEFAULT_RETURN_PATH} replace />;
  }

  return <Navigate to="/auth" />;
};

export default FacebookRoute;
